import React from "react";
import cns from "classnames";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  [other: string]: any;
  fullWidth?: boolean;
};

export function ControlsRow(props: Props) {
  const classes = useStyles({});
  const { className, fullWidth, children, ...rest } = props;
  return (
    <div
      className={cns(classes.root, className, { [classes.fullWidth]: fullWidth })}
      {...rest}
    >
      {children}
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    alignItems: "center",
    display: "flex",
    flex: "0 0 0",
    justifyContent: "flex-end",

    "& > *:not(:last-child)": {
      marginRight: theme.spacing()
    }
  },

  fullWidth: {
    flexGrow: 1
  }
}));
